import { useNavigate } from "react-router-dom";
import { Users, PiggyBank, HandCoins, Clock, Inbox, UserPlus, ArrowRight } from "lucide-react";
import { AdminTitle } from "@/admin/AdminLayout";
import { GradientStat } from "@/components/Colorful";
import { useApi } from "@/lib/api";
import { rp, fmtDateTime, KIND_LABEL } from "@/lib/format";

const Recent = ({ title, items, empty, to, render, testid }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm" data-testid={testid}>
      <div className="flex justify-between items-center mb-3">
        <h2 className="font-bold text-slate-900">{title}</h2>
        <button onClick={() => navigate(to)} className="text-xs font-semibold text-blue-700 flex items-center gap-1 hover:underline">Lihat semua <ArrowRight className="h-3 w-3" /></button>
      </div>
      {items.length === 0 ? <p className="text-sm text-slate-500">{empty}</p> : <div className="divide-y divide-slate-100">{items.slice(0, 5).map(render)}</div>}
    </div>
  );
};

export default function AdminDashboard() {
  const navigate = useNavigate();
  const { data } = useApi("/admin/stats");
  const { data: regs } = useApi("/admin/registrations");
  const { data: reqs } = useApi("/admin/requests");
  const cards = [
    { k: "members", tone: "blue", l: "Total Anggota", icon: Users, v: data?.members, sub: "Anggota terdaftar", to: "/admin/anggota" },
    { k: "total_savings", tone: "green", l: "Total Simpanan", icon: PiggyBank, v: rp(data?.total_savings), sub: "Pokok + wajib + sukarela", to: "/admin/anggota" },
    { k: "outstanding_loans", tone: "orange", l: "Piutang Pinjaman", icon: HandCoins, v: rp(data?.outstanding_loans), sub: "Sisa pinjaman aktif", to: "/admin/pinjaman" },
    { k: "pending_registrations", tone: "purple", l: "Pendaftaran Baru", icon: UserPlus, v: data?.pending_registrations ?? 0, sub: "Menunggu ditinjau", to: "/admin/pendaftaran" },
    { k: "pending_loans", tone: "red", l: "Pengajuan Pinjaman", icon: Clock, v: data?.pending_loans ?? 0, sub: "Menunggu persetujuan", to: "/admin/pinjaman" },
    { k: "pending_requests", tone: "teal", l: "Pembayaran & Transfer", icon: Inbox, v: data?.pending_requests ?? 0, sub: "Perlu diverifikasi", to: "/admin/permintaan" },
  ];
  return (
    <div>
      <AdminTitle title="Dasbor Pengurus" sub="Ringkasan CU Tuah Talino hari ini" />
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {cards.map(({ k, tone, l, icon, v, sub, to }, i) => (
          <GradientStat key={k} tone={tone} icon={icon} label={l} value={v ?? "-"} sub={sub} onClick={() => navigate(to)} testid={`admin-stat-${k}`} delay={i * 60} />
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-4 mt-6">
        <Recent title="Pendaftaran Terbaru" testid="dashboard-recent-registrations" to="/admin/pendaftaran" empty="Belum ada pendaftaran menunggu."
          items={(regs || []).filter((r) => r.status === "pending")}
          render={(r) => (
            <div key={r.reg_id} className="py-2.5 flex justify-between text-sm">
              <div><b>{r.name}</b><div className="text-xs text-slate-500">{r.email}</div></div>
              <span className="text-xs text-slate-500">{fmtDateTime(r.created_at)}</span>
            </div>
          )} />
        <Recent title="Verifikasi Menunggu" testid="dashboard-recent-requests" to="/admin/permintaan" empty="Tidak ada pembayaran/transfer menunggu."
          items={(reqs || []).filter((r) => r.status === "pending")}
          render={(r) => (
            <div key={r.req_id} className="py-2.5 flex justify-between text-sm">
              <div><b>{KIND_LABEL[r.kind]}</b><div className="text-xs text-slate-500">{r.member_name} • {r.member_no}</div></div>
              <b className="text-emerald-600">{rp(r.amount)}</b>
            </div>
          )} />
      </div>
    </div>
  );
}
